module.exports = __webpack_public_path__ + "img/ph_2.d47b4fb8.jpg";